
<template>
    <div>

        <div class="container" v-if="record">
            <div class="row">

                <div class="col-lg-12"> 
                    <h3 class="mb-0 text-uppercase">Internship Documents</h3>
                    <hr class="my-4" />
                </div>

                <div 
                    class="col-lg-12" 
                    v-if="record && record.documents && record.documents.length > 0"
                >
                    <div class="row">
                        <div 
                            class="col-sm-6 text-center borderLine" 
                            v-for="(document, index) in record.documents"
                            :key="index"
                        >      
                            <br>
                            <h4 class="text-capitalize height-50"> 
                                {{document.name ? document.name : 'No Document Uploaded'}}
                            </h4><br>  
                            <base-button 
                                type="primary" 
                                size="sm" 
                                v-if="document.hasFile"
                                @click="viewDocument('internship_performance/' + document.filename, index)"
                            >
                                <i class="fa fa-eye"></i> 
                                {{ isLoading && (isIndex == index) ? 'Please Wait...' : 'View File'}}
                            </base-button>  

                            <badge size="sm" 
                                type="danger"
                                v-if="! document.hasFile"
                            >
                                No Document Uploaded
                            </badge>        
                        </div>
                    </div>
                </div>

                <div 
                    class="table-responsive"
                    v-if="record && record.documents && record.documents.length > 0"
                >
                    <br>
                    <table class="table table-bordered">
                        <thead>
                            <th>Internship Start Date</th>
                            <th>Internship End Date</th>
                        </thead>

                        <tbody>
                            <td>
                                <h4 class="font-weight-light">
                                    {{ record.start_date | formatDate }}
                                </h4>
                            </td>
                            <td>
                                <h4 class="font-weight-light">
                                    {{ record.end_date | formatDate }}
                                </h4>
                            </td>
                        </tbody> 
                    </table>

                </div>

                <div 
                    v-if="record && record.documents && record.documents.length == 0"
                    class="col-sm-12 text-center"
                >
                    <base-alert type="warning">
                        <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                        <span class="alert-inner--text">
                            No documents added yet!!!
                        </span>
                    </base-alert>
                </div>

                <div class="col-lg-12">
                    <hr class="my-4" />
                </div>
            </div>  
        </div>

    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import moment from 'moment';
    import swal from 'sweetalert2';

    export default {
        name: 'InternshipDocuments',
        props: ['userData'],
        data() {
            return {
                record: null,
                isLoadingBlade: true,
                isLoading: false,
                isIndex: null
            }
        },
        filters: {
            formatDate(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            }
        },
        methods: {
            ...mapActions(['getInternshipRecords', 'viewUserDocument']),
            loadInternshipRecords() {// load Application
                if(this.userData) {
                    this.getInternshipRecords({id : this.userData.id}).then((res) => {// get records
                    this.record = res;
                    this.isLoadingBlade = false;
                    }).
                    catch(() => {
                        this.isLoadingBlade = false;
                        this.showErrorStatus = true;
                        this.errorMsg = "Server Failure!, Kindly reload the page...";
                        this.errorType = 'danger';
                    });
                } else {
                    this.isLoadingBlade = false;
                    this.showErrorStatus = true;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                }
            },
            getStatus(status) {
                return (status == 'yes') ? 'Current' : 'Past';
            },
            async viewDocument(filename, index) {// view user document
                if(this.userData) {
                    this.isLoading = true;
                    this.isIndex = index;
                    this.viewUserDocument({filename : filename, id: this.userData.user_id}).then(() => {
                        this.isLoading = false; // document will be opened in new tab      
                        this.isIndex = null;              
                    }).
                    catch(err => {
                        swal.fire(err.message+"!", "An error occurred while fetching document, try again...", "warning");
                    });
                } else {
                    swal.fire("Error!", "User account was not found", "error");
                }                
            }
        },
        mounted() {
            this.loadInternshipRecords(); // load internship records
        }
    };
</script>
<style scoped>
    .marginTop40 {
        margin-top: 40px;
    }
</style>
